import { render, staticRenderFns } from "./divarMulti.vue?vue&type=template&id=8c3fa2d0&scoped=true"
import script from "./divarMulti.vue?vue&type=script&lang=js"
export * from "./divarMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3fa2d0",
  null
  
)

export default component.exports